import * as types from './mutation-types';
import API from '@/services/commonApi';
import { AUCTIONEERLIVE, GETINVENTORYPROJECTDETAILS, SETPAYMENTTIME } from '@/utils/endpoint';
import Hub from '@/events/hub';

const actions = {
  getAuctioneerLive: ({ commit }, auctionId) => {
    API.get(`${AUCTIONEERLIVE}${auctionId}/`)
      .then((response) => {
        commit(types.GETAUCTIONEERLIVE, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  updateAuctioneerLive: ({ commit }, payload) => {
    commit(types.UPDATEAUCTIONEERLIVE, payload);
  },
  showAuctionPausedStatus: ({ _commit }, payload) => {
    if (payload) {
      Hub.$emit('open-modal');
      Hub.$emit('set-modal-data', {
        onlyMessage: true,
        message: 'All auctions are paused. Please try again later!',
      }, 'confirmation');
    }
  },
  getInventoryDetails: ({ commit }, projectId) => {
    API.get(`${GETINVENTORYPROJECTDETAILS}${projectId}/`)
      .then((response) => {
        commit(types.GETINVENTORYPROJECTDETAILS, response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  setPaymentTime: ({ _commit }, payload) => {
    const data = {
      time_for_payment: payload.time_payment,
    };
    API.put(`${SETPAYMENTTIME + payload.auction_id}/`, data)
      .then(() => {
        payload.cb_success();
      })
      .catch((error) => {
        console.log(error);
        payload.cb_error();
      });
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/auctioneer/actions.js